import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';

@autobind
class BaseballMatchTeamStatModel {
  location;

  constructor(data, location) {
    extendObservable(this, data);

    this.location = location;
  }

  @computed
  get chart() {
    const { pitEra, batOps, batAvg, batHr, batSb, pitWhip, fldErr } = this;

    let result = {
      era: { p: 0, v: '' },
      ops: { p: 0, v: '' },
      avg: { p: 0, v: '' },
      hr: '',
      sb: '',
      whip: { p: 0, v: '' },
      err: ''
    };

    // 타율 -                 batAvg: 0.273
    // 평균자책점 -           pitEra: 3.92308
    // 홈런 -                 batHr: 19
    // ops -                  batOps: 0.807
    // 도루 -                 batSb: 80
    // whip 이닝당 출루허용 - pitWhip: 1.28205
    // 실책 -                 fldErr: 31

    // 평균 자책점  - 7을 기준으로 7이상일 경우 100% 고정 (낮은숫자가 빨간색)
    // whip         - 3을 기준으로 3이상일 경우 100% 고정 (낮은숫자가 빨간색)
    // OPS - 1.000 기준, 높은것에 빨강, 1이상이면 100%
    // 타율 - 0.500 기준, 높은것에 빨강, 0.500 이상이면 100%
    // 홈런, 도루 - 두자리일 경우 100개 기준, 3자리일 경우 100단위 + 1, 높은것에 빨강
    // 실책 - 두자리일 경우 100개 기준, 3자리일 경우 100단위 + 1, 낮은것에 빨강

    // 평균 자책점
    if (!!pitEra) {
      const era = +((pitEra / 7) * 100).toFixed(1);

      result.era = {
        p: era > 100 ? 100 : era,
        v: pitEra.toFixed(2)
      };
    }

    // OPS
    if (!!batOps) {
      const ops = +((batOps / 1) * 100).toFixed(1);

      result.ops = {
        p: ops > 100 ? 100 : ops,
        v: batOps.toFixed(3)
      };
    }

    // 타율
    if (!!batAvg) {
      const avg = +((batAvg / 0.5) * 100).toFixed(1);

      result.avg = {
        p: avg > 100 ? 100 : avg,
        v: batAvg.toFixed(3)
      };
    }

    // 홈런
    if (!!batHr) {
      result.hr = batHr;
    }

    // 도루
    if (!!batSb) {
      result.sb = batSb;
    }

    //  whip
    if (!!pitWhip) {
      const whip = +((pitWhip / 3) * 100).toFixed(1);

      result.whip = {
        p: whip > 100 ? 100 : whip,
        v: pitWhip.toFixed(2)
      };
    }

    if (!!fldErr) {
      result.err = fldErr;
    }

    return result;
  }

  @computed
  get player() {
    const { starterPitcingStat, vsName } = this;

    let result = {
      name: '미정',
      visible: false,
      noDataWlq: '선발투수가 확정되면',
      noDataVs: '업데이트 됩니다',
      wlq: '0승 0패 QS 0',
      vs: `vs ${vsName} 시즌 전적 없음`
    };

    if (!!starterPitcingStat && !!starterPitcingStat.player) {
      const { player } = starterPitcingStat;

      result.visible = true;
      result.name = player.displayName;

      if (
        !!starterPitcingStat.pitWin &&
        !!starterPitcingStat.pitLoss &&
        !!starterPitcingStat.pitQs
      ) {
        result.wlq = `${starterPitcingStat.pitWin}승 ${starterPitcingStat.pitLoss}패 QS ${starterPitcingStat.pitQs}`;
      }

      if (!!starterPitcingStat.vsStat) {
      }
    }

    return result;
  }

  @computed
  get seasonBatList() {
    const { seasonBattingStats } = this;

    if (seasonBattingStats.length > 0) {
      return seasonBattingStats
        .sort((a, b) => {
          if (a.batHit > b.batHit) return -1;
          if (a.batHit < b.batHit) return 1;
          else return 0;
        })
        .slice(0, 10);
    } else {
      return [];
    }
  }

  @computed
  get seasonVsBatList() {
    const { seasonVsBattingStats } = this;

    if (seasonVsBattingStats.length > 0) {
      return seasonVsBattingStats
        .sort((a, b) => {
          if (a.batHit > b.batHit) return -1;
          if (a.batHit < b.batHit) return 1;
          else return 0;
        })
        .slice(0, 10);
    } else {
      return [];
    }
  }

  @computed
  get specialChart() {
    const { firstBaseOnBall, firstHomerun, firstStrikeOut, seasonStat } = this;

    let result = {
      bob: { p: 0, v: '' },
      hr: { p: 0, v: '' },
      so: { p: 0, v: '' }
    };

    if (!!seasonStat) {
      result = {
        bob: { p: 0, v: firstBaseOnBall },
        hr: { p: 0, v: firstHomerun },
        so: { p: 0, v: firstStrikeOut }
      };

      const keys = Object.keys(seasonStat);
      const gameCount = keys.reduce((a, c) => (a += seasonStat[c]), 0);

      for (let [key, value] of Object.entries(result)) {
        const v = +((value.v / gameCount) * 100).toFixed(1);

        result[key].p = v > 100 ? 100 : v;
        result[key].v = value.v > 0 ? `${value.v}/${gameCount}` : '';
      }
    }

    return result;
  }

  @computed
  get stat() {
    const { seasonStat, vsStat } = this;

    if (!!seasonStat && !!vsStat) {
      return {
        season: `${seasonStat.win}승 ${seasonStat.lose}패`,
        vs: `${vsStat.win}승 ${vsStat.lose}패`
      };
    } else {
      return {
        season: '',
        vs: ''
      };
    }
  }
}

export default BaseballMatchTeamStatModel;
